import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      d: "M1.38 11.38 13.16 23a2 2 0 0 0 1.39.56A2 2 0 0 0 16 23l7.06-7.07A2 2 0 0 0 23 13L11.3 1.5l-.05-.06a3.78 3.78 0 0 0-2.39-1h-6.5a2 2 0 0 0-2 2V9a3.78 3.78 0 0 0 1.02 2.38m3.48-4.92A1.5 1.5 0 1 1 6.36 8a1.5 1.5 0 0 1-1.5-1.54"
    }, null, -1)
  ]));
}
const interfaceBookmarkTag = { render };
export {
  interfaceBookmarkTag as default,
  render
};
//# sourceMappingURL=interface-bookmark-tag.svg.js.map
